var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.75V8.25C29 7.005 27.995 6 26.75 6H5.73499C4.48999 6 3.48499 7.005 3.48499 8.25V21.75C3.48499 22.995 4.48999 24 5.73499 24H26.75C27.995 24 29 22.995 29 21.75ZM27.035 8.085C27.53 8.58 27.26 9.09 26.99 9.345L20.9 14.925L26.75 21.015C26.93 21.225 27.05 21.555 26.84 21.78C26.645 22.02 26.195 22.005 26 21.855L19.445 16.26L16.235 19.185L13.04 16.26L6.48499 21.855C6.28999 22.005 5.83999 22.02 5.64499 21.78C5.43499 21.555 5.55499 21.225 5.73499 21.015L11.585 14.925L5.49499 9.345C5.22499 9.09 4.95499 8.58 5.44999 8.085C5.94499 7.59 6.45499 7.83 6.87499 8.19L16.235 15.75L25.61 8.19C26.03 7.83 26.54 7.59 27.035 8.085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3c2a901e8ca1201449c34ccaa22596ef.svg";
export { ForwardRef as ReactComponent };